(function () {
  function initBuilder(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var labels = {};
    var labelsNode = root.querySelector('[data-builder-labels]');
    if (labelsNode) {
      try { labels = JSON.parse(labelsNode.textContent); } catch (error) { labels = {}; }
    }
    var isArabic = document.documentElement.dir === 'rtl' || /^ar/i.test(document.documentElement.lang || '');
    var checkoutCta = labels.checkoutCta || (isArabic ? 'المتابعة إلى الدفع' : 'Continue to Checkout');
    labels.itemRequired = labels.checkoutItemRequired || (isArabic ? 'يرجى اختيار عنصر واحد على الأقل من الألعاب أو الطعام أو الديكور قبل المتابعة إلى الدفع.' : 'Please select at least 1 item from Inflatables, Food Station, or Decor before checkout.');
    labels.cartError = labels.checkoutError || (isArabic ? 'تعذر تجهيز صفحة الدفع. حاول مرة أخرى.' : 'We could not prepare checkout. Please try again.');
    labels.autosaveTitle = labels.autosaveTitle || (isArabic ? 'لديك باقة محفوظة' : 'Saved package found');
    labels.autosaveBody = labels.autosaveBody || (isArabic ? 'يمكنك متابعة الباقة التي جهزتها سابقاً.' : 'Continue the package you built earlier.');
    labels.autosaveContinue = labels.autosaveContinue || (isArabic ? 'متابعة الباقة' : 'Continue package');
    labels.autosaveStartOver = labels.autosaveStartOver || (isArabic ? 'ابدأ من جديد' : 'Start fresh');
    labels.add = labels.add || (isArabic ? 'أضف' : 'Add');
    labels.remove = labels.remove || (isArabic ? 'إزالة' : 'Remove');

    var AUTOSAVE_KEY = 'kumm:garden-party-builder:v1';
    var AUTOSAVE_MAX_AGE = 1000 * 60 * 60 * 24 * 30;
    var state = { selected: {}, addons: {}, upsell: {}, days: 1 };
    var delivery = Number(root.dataset.deliveryPrice || 100);
    var bundleDiscountPercent = Math.max(0, Number(root.dataset.bundleDiscountPercent || 18));
    var bundleDiscountRate = bundleDiscountPercent / 100;
    var dateInput = root.querySelector('#party-date');
    var dateTrigger = root.querySelector('#party-date-trigger');
    var dateTriggerValue = root.querySelector('#party-date-trigger-value');
    var dateDialog = root.querySelector('#party-date-dialog');
    var calendarGrid = root.querySelector('[data-calendar-grid]');
    var calendarWeekdays = root.querySelector('[data-calendar-weekdays]');
    var calendarTitle = root.querySelector('#party-date-dialog-title');
    var calendarPrevious = root.querySelector('[data-calendar-prev]');
    var calendarNext = root.querySelector('[data-calendar-next]');
    var calendarViewDate = null;
    var daysInput = root.querySelector('#party-days');
    var guestsInput = root.querySelector('#party-guests');
    var venueInput = root.querySelector('#venue-type');
    var notesInput = root.querySelector('#party-notes');
    var cityNode = root.querySelector('#delivery-city');
    var drawer = root.querySelector('#mobile-drawer');
    var overlay = root.querySelector('#mobile-drawer-overlay');
    var activeTab = 0;
    var saveReady = false;
    var suppressSave = false;
    var saveTimer = null;
    var pendingDraft = null;
    var restorePrompt = null;
    var localStore = getLocalStore();
    var stickyOffsetFrame = null;

    function normalizeDigits(value) {
      return String(value == null ? '' : value)
        .replace(/[\u0660-\u0669]/g, function (digit) { return String(digit.charCodeAt(0) - 0x0660); })
        .replace(/[\u06f0-\u06f9]/g, function (digit) { return String(digit.charCodeAt(0) - 0x06f0); });
    }

    function normalizeBuilderDigits(container) {
      if (!isArabic || !container) return;
      var nodes = [];
      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var parent = node.parentElement;
          if (!parent || /^(SCRIPT|STYLE|TEXTAREA)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
          return /[\u0660-\u0669\u06f0-\u06f9]/.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      var node = walker.nextNode();
      while (node) {
        nodes.push(node);
        node = walker.nextNode();
      }
      nodes.forEach(function (textNode) {
        textNode.nodeValue = normalizeDigits(textNode.nodeValue);
      });
    }

    function formatDateInputValue(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return [year, month, day].join('-');
    }

    function parseDateInputValue(value) {
      if (!value) return null;
      var parts = value.split('-').map(Number);
      if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) return null;
      return new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0, 0);
    }

    function refreshPartyDateMinimum() {
      if (!dateInput) return;
      var earliestDate = new Date();
      earliestDate.setHours(12, 0, 0, 0);
      earliestDate.setDate(earliestDate.getDate() + 1);
      dateInput.min = formatDateInputValue(earliestDate);
      if (dateInput.value && dateInput.value < dateInput.min) dateInput.value = '';
      updateDateTriggerValue(dateInput.value);
    }

    function money(value) {
      var number = Math.round(Number(value || 0));
      return number.toLocaleString('en-US') + ' SR';
    }

    function getLocalStore() {
      try {
        var store = window.localStorage;
        var testKey = 'kumm-party-storage-test';
        store.setItem(testKey, '1');
        store.removeItem(testKey);
        return store;
      } catch (error) {
        return null;
      }
    }

    function updateStickySummaryOffset() {
      if (window.innerWidth <= 1024) return;
      var selectors = [
        '.shopify-section-header',
        '.shopify-section-group-header-group',
        '.section-header',
        'sticky-header',
        'header[role="banner"]',
        '.header-wrapper',
        '.site-header'
      ];
      var elements = [];
      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (el) {
          if (elements.indexOf(el) === -1) elements.push(el);
        });
      });
      var headerBottoms = [];
      elements.forEach(function (el) {
        if (!el || root.contains(el)) return;
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        if (style.position !== 'fixed' && style.position !== 'sticky' && style.position !== '-webkit-sticky') return;
        var rect = el.getBoundingClientRect();
        if (rect.height < 1 || rect.bottom <= 0 || rect.top > 6) return;
        if (rect.bottom > window.innerHeight * 0.4) return;
        headerBottoms.push(rect.bottom);
      });
      var headerBottom = headerBottoms.length ? Math.min.apply(Math, headerBottoms) : 0;
      var offset = headerBottom ? Math.ceil(headerBottom + 4) : 72;
      root.style.setProperty('--kumm-summary-offset', Math.max(56, offset) + 'px');
    }

    function queueStickySummaryOffset() {
      window.cancelAnimationFrame(stickyOffsetFrame);
      stickyOffsetFrame = window.requestAnimationFrame(updateStickySummaryOffset);
    }

    function productFromCard(card) {
      return {
        id: card.dataset.id,
        productId: card.dataset.productId,
        variantId: card.dataset.variantId,
        section: card.dataset.section,
        price: Number(card.dataset.price || 0),
        priceCents: Number(card.dataset.priceCents || 0),
        type: card.dataset.type,
        nameEn: card.dataset.nameEn,
        nameAr: card.dataset.nameAr,
        img: card.dataset.img
      };
    }

    function addonFromCard(card, key) {
      return {
        key: key,
        price: Number(card.dataset.addonPrice || 0),
        nameEn: card.dataset.addonEn || labels.addon || 'Add-on',
        nameAr: card.dataset.addonAr || labels.addon || 'Add-on',
        icon: card.dataset.addonIcon || '+'
      };
    }

    function upsellFromCard(card) {
      return {
        id: card.dataset.upsellId,
        variantId: card.dataset.variantId,
        price: Number(card.dataset.upsellPrice || 0),
        priceCents: Number(card.dataset.upsellPriceCents || 0),
        nameEn: card.dataset.upsellEn,
        nameAr: card.dataset.upsellAr,
        img: card.dataset.img,
        section: 'upsell'
      };
    }

    function getFormFields() {
      return {
        date: dateInput ? dateInput.value : '',
        days: daysInput ? daysInput.value : '1',
        guests: guestsInput ? guestsInput.value : '',
        venue: venueInput ? venueInput.value : '',
        notes: notesInput ? notesInput.value.trim().slice(0, 300) : '',
        city: cityNode ? cityNode.textContent.trim() : labels.deliveryCity || ''
      };
    }

    function buildDraft() {
      return {
        version: 1,
        updatedAt: Date.now(),
        activeTab: activeTab,
        fields: getFormFields(),
        selectedIds: Object.keys(state.selected),
        addonKeys: Object.keys(state.addons),
        upsellIds: Object.keys(state.upsell)
      };
    }

    function hasDraftData(draft) {
      var fields = draft && draft.fields ? draft.fields : {};
      return Boolean(
        draft &&
        ((draft.selectedIds || []).length ||
          (draft.addonKeys || []).length ||
          (draft.upsellIds || []).length ||
          fields.date ||
          fields.guests ||
          fields.venue ||
          fields.notes ||
          (fields.days && fields.days !== '1'))
      );
    }

    function readDraft() {
      if (!localStore) return null;
      try {
        var draft = JSON.parse(localStore.getItem(AUTOSAVE_KEY) || 'null');
        if (!draft || draft.version !== 1 || !hasDraftData(draft)) return null;
        if (Date.now() - Number(draft.updatedAt || 0) > AUTOSAVE_MAX_AGE) {
          localStore.removeItem(AUTOSAVE_KEY);
          return null;
        }
        return draft;
      } catch (error) {
        return null;
      }
    }

    function clearDraft() {
      if (!localStore) return;
      try { localStore.removeItem(AUTOSAVE_KEY); } catch (error) {}
    }

    function saveDraftNow() {
      if (!localStore || !saveReady || suppressSave) return;
      var draft = buildDraft();
      try {
        if (hasDraftData(draft)) localStore.setItem(AUTOSAVE_KEY, JSON.stringify(draft));
        else localStore.removeItem(AUTOSAVE_KEY);
      } catch (error) {}
    }

    function queueSaveDraft() {
      dismissRestorePrompt();
      if (!saveReady || suppressSave) return;
      window.clearTimeout(saveTimer);
      saveTimer = window.setTimeout(saveDraftNow, 120);
    }

    function findDataCard(selector, attr, value) {
      var cards = root.querySelectorAll(selector);
      for (var i = 0; i < cards.length; i += 1) {
        if (cards[i].dataset[attr] === String(value)) return cards[i];
      }
      return null;
    }

    function setSelectValue(select, value, fallback) {
      if (!select) return;
      var next = String(value || fallback || '');
      var hasOption = Array.prototype.some.call(select.options, function (option) {
        return option.value === next;
      });
      select.value = hasOption ? next : fallback || '';
    }

    function validSavedDate(value) {
      if (!value || !dateInput) return '';
      return !dateInput.min || value >= dateInput.min ? value : '';
    }

    function cardTitle(card) {
      var title = isArabic ? card.dataset.nameAr || card.dataset.upsellAr || card.dataset.addonAr || '' : card.dataset.nameEn || card.dataset.upsellEn || card.dataset.addonEn || '';
      return normalizeDigits(title);
    }

    function setToggleButton(button, selected, title) {
      if (!button) return;
      var label = selected ? labels.remove : labels.add;
      button.textContent = selected ? label : '+ ' + label;
      button.setAttribute('aria-label', label + (title ? ' ' + title : ''));
    }

    function updateCardActions() {
      root.querySelectorAll('.kumm-prod-card').forEach(function (card) {
        var button = card.querySelector('.prod-add');
        if (!button) return;
        var selected = card.classList.contains('sel');
        button.classList.toggle('is-remove', selected);
        button.setAttribute('aria-label', (selected ? labels.remove : labels.add) + ' ' + cardTitle(card));
      });

      root.querySelectorAll('.addon-card:not(.upsell-card)').forEach(function (card, idx) {
        setToggleButton(card.querySelector('.addon-tog'), Boolean(state.addons['addon_' + idx]), cardTitle(card));
      });

      root.querySelectorAll('.upsell-card').forEach(function (card) {
        setToggleButton(card.querySelector('.upsell-tog'), Boolean(state.upsell[card.dataset.upsellId]), cardTitle(card));
      });
    }

    function applyDraft(draft) {
      if (!draft || !hasDraftData(draft)) return;
      hydrateAllProducts();
      suppressSave = true;
      state.selected = {};
      state.addons = {};
      state.upsell = {};
      root.querySelectorAll('.kumm-prod-card.sel').forEach(function (card) { card.classList.remove('sel'); });
      root.querySelectorAll('.addon-card.sel, .addon-card.addon-selected').forEach(function (card) {
        card.classList.remove('sel', 'addon-selected');
      });

      var fields = draft.fields || {};
      if (dateInput) dateInput.value = validSavedDate(fields.date);
      setSelectValue(daysInput, fields.days, '1');
      setSelectValue(guestsInput, fields.guests, '');
      setSelectValue(venueInput, fields.venue, '');
      if (notesInput) notesInput.value = fields.notes || '';

      (draft.selectedIds || []).forEach(function (id) {
        var card = findDataCard('.kumm-prod-card', 'id', id);
        if (!card) return;
        state.selected[card.dataset.id] = productFromCard(card);
        card.classList.add('sel');
      });

      (draft.addonKeys || []).forEach(function (key) {
        var idx = Number(String(key).replace('addon_', ''));
        var card = root.querySelectorAll('.addon-card:not(.upsell-card)')[idx];
        if (!card) return;
        state.addons[key] = addonFromCard(card, key);
        card.classList.add('sel');
      });

      (draft.upsellIds || []).forEach(function (id) {
        var card = findDataCard('.upsell-card', 'upsellId', id);
        if (!card) return;
        state.upsell[card.dataset.upsellId] = upsellFromCard(card);
        card.classList.add('addon-selected');
      });

      activeTab = Math.max(0, Math.min(2, Number(draft.activeTab) || 0));
      suppressSave = false;
      clearErrors();
      switchTab(activeTab);
      updateUI();
      saveDraftNow();
    }

    function dismissRestorePrompt() {
      if (!restorePrompt) return;
      restorePrompt.remove();
      restorePrompt = null;
      pendingDraft = null;
    }

    function showRestorePrompt(draft) {
      if (!draft || restorePrompt) return;
      pendingDraft = draft;
      restorePrompt = document.createElement('div');
      restorePrompt.className = 'autosave-restore';
      restorePrompt.setAttribute('role', 'status');
      restorePrompt.innerHTML =
        '<div class="autosave-copy"><strong></strong><span></span></div>' +
        '<div class="autosave-actions"><button type="button" class="autosave-continue" data-restore-draft></button><button type="button" class="autosave-clear" data-clear-draft></button></div>';
      restorePrompt.querySelector('strong').textContent = labels.autosaveTitle;
      restorePrompt.querySelector('span').textContent = labels.autosaveBody;
      restorePrompt.querySelector('[data-restore-draft]').textContent = labels.autosaveContinue;
      restorePrompt.querySelector('[data-clear-draft]').textContent = labels.autosaveStartOver;
      var grid = root.querySelector('.page-grid');
      root.insertBefore(restorePrompt, grid || root.firstChild);
    }

    function setCheckoutCta() {
      root.querySelectorAll('[data-add-bundle], [data-mobile-add]').forEach(function (btn) {
        btn.textContent = checkoutCta + (btn.hasAttribute('data-add-bundle') ? (isArabic ? ' ←' : ' →') : '');
      });
    }

    function textFor(item) {
      return normalizeDigits(document.documentElement.dir === 'rtl' ? (item.nameAr || item.nameEn) : (item.nameEn || item.nameAr));
    }

    function formatPartyDate(value) {
      if (!value) return '';
      var parts = value.split('-').map(Number);
      var date = new Date(parts[0], parts[1] - 1, parts[2]);
      try {
        return normalizeDigits(new Intl.DateTimeFormat(isArabic ? 'ar-SA-u-ca-gregory-nu-latn' : 'en-SA', {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }).format(date));
      } catch (error) {
        return value;
      }
    }

    function formatRentalDate(value) {
      if (!value) return '';
      var parts = value.split('-').map(Number);
      var date = new Date(parts[0], parts[1] - 1, parts[2]);
      try {
        return normalizeDigits(new Intl.DateTimeFormat(isArabic ? 'ar-SA-u-ca-gregory-nu-latn' : 'en-SA', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }).format(date));
      } catch (error) {
        return value;
      }
    }

    function rentalDateRange(value, days) {
      if (!value) return '';
      var parts = value.split('-').map(Number);
      var endDate = new Date(parts[0], parts[1] - 1, parts[2]);
      endDate.setDate(endDate.getDate() + Math.max(0, Number(days || 1) - 1));
      return formatRentalDate(value) + ' => ' + formatRentalDate(formatDateInputValue(endDate));
    }

    function updateDateTriggerValue(value) {
      if (!dateTriggerValue || !dateTrigger) return;
      dateTriggerValue.textContent = value ? formatPartyDate(value) : (labels.selectDate || (isArabic ? 'اختر تاريخ الحفلة' : 'Select party date'));
      dateTrigger.classList.toggle('has-value', Boolean(value));
    }

    function formatCalendarMonth(date) {
      try {
        return normalizeDigits(new Intl.DateTimeFormat(isArabic ? 'ar-SA-u-ca-gregory-nu-latn' : 'en-SA', {
          year: 'numeric',
          month: 'long'
        }).format(date));
      } catch (error) {
        return [date.getFullYear(), date.getMonth() + 1].join('-');
      }
    }

    function renderCalendarWeekdays() {
      if (!calendarWeekdays) return;
      calendarWeekdays.innerHTML = '';
      var formatter;
      try {
        formatter = new Intl.DateTimeFormat(isArabic ? 'ar-SA-u-ca-gregory-nu-latn' : 'en-SA', { weekday: 'short' });
      } catch (error) {
        formatter = null;
      }
      for (var index = 0; index < 7; index += 1) {
        var label = document.createElement('span');
        var weekday = new Date(2026, 6, 5 + index, 12, 0, 0, 0);
        label.textContent = formatter ? normalizeDigits(formatter.format(weekday)) : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][index];
        calendarWeekdays.appendChild(label);
      }
    }

    function renderPartyDateCalendar() {
      if (!dateInput || !calendarGrid || !calendarTitle || !calendarViewDate) return;
      refreshPartyDateMinimum();
      var minimumDate = parseDateInputValue(dateInput.min);
      var selectedValue = dateInput.value;
      var todayValue = formatDateInputValue(new Date());
      var year = calendarViewDate.getFullYear();
      var month = calendarViewDate.getMonth();
      var firstWeekday = new Date(year, month, 1, 12, 0, 0, 0).getDay();
      var daysInMonth = new Date(year, month + 1, 0, 12, 0, 0, 0).getDate();
      var minimumMonth = minimumDate.getFullYear() * 12 + minimumDate.getMonth();
      var visibleMonth = year * 12 + month;

      calendarTitle.textContent = formatCalendarMonth(calendarViewDate);
      if (calendarPrevious) calendarPrevious.disabled = visibleMonth <= minimumMonth;
      calendarGrid.innerHTML = '';

      for (var blankIndex = 0; blankIndex < firstWeekday; blankIndex += 1) {
        var blank = document.createElement('span');
        blank.className = 'party-date-blank';
        blank.setAttribute('aria-hidden', 'true');
        calendarGrid.appendChild(blank);
      }

      for (var day = 1; day <= daysInMonth; day += 1) {
        var date = new Date(year, month, day, 12, 0, 0, 0);
        var dateValue = formatDateInputValue(date);
        var unavailable = dateValue < dateInput.min;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'party-date-day';
        button.dataset.calendarDate = dateValue;
        button.textContent = normalizeDigits(String(day));
        button.disabled = unavailable;
        button.setAttribute('role', 'gridcell');
        button.setAttribute('aria-label', formatPartyDate(dateValue));
        button.setAttribute('aria-selected', dateValue === selectedValue ? 'true' : 'false');
        button.classList.toggle('is-selected', dateValue === selectedValue);
        button.classList.toggle('is-today', dateValue === todayValue);
        if (unavailable) button.setAttribute('aria-disabled', 'true');
        calendarGrid.appendChild(button);
      }
    }

    function openPartyDateCalendar() {
      if (!dateInput || !dateDialog) return;
      refreshPartyDateMinimum();
      var initialDate = parseDateInputValue(dateInput.value) || parseDateInputValue(dateInput.min);
      calendarViewDate = new Date(initialDate.getFullYear(), initialDate.getMonth(), 1, 12, 0, 0, 0);
      renderCalendarWeekdays();
      renderPartyDateCalendar();
      if (typeof dateDialog.showModal === 'function') {
        if (!dateDialog.open) dateDialog.showModal();
      } else {
        dateDialog.setAttribute('open', '');
      }
    }

    function closePartyDateCalendar() {
      if (!dateDialog) return;
      if (typeof dateDialog.close === 'function' && dateDialog.open) dateDialog.close();
      else dateDialog.removeAttribute('open');
    }

    function moveCalendarMonth(offset) {
      if (!calendarViewDate) return;
      calendarViewDate = new Date(calendarViewDate.getFullYear(), calendarViewDate.getMonth() + offset, 1, 12, 0, 0, 0);
      renderPartyDateCalendar();
    }

    function selectCalendarDate(value) {
      refreshPartyDateMinimum();
      if (!dateInput || !value || value < dateInput.min) return;
      dateInput.value = value;
      clearErrors();
      updateUI();
      closePartyDateCalendar();
      if (dateTrigger) dateTrigger.focus();
    }

    function setDisplay(id, value, html) {
      var displayValue = isArabic ? normalizeDigits(value) : value;
      root.querySelectorAll('#' + id).forEach(function (el) {
        if (html) el.innerHTML = displayValue;
        else el.textContent = displayValue;
      });
    }

    function setVisible(id, visible) {
      root.querySelectorAll('#' + id).forEach(function (el) {
        el.style.display = visible ? 'flex' : 'none';
      });
    }

    function updateProgressBars(progress, active, count) {
      var safeProgress = Math.max(0, Math.min(100, Number(progress) || 0));
      var safeCount = Math.max(0, Math.min(3, Number(count) || 0));
      root.style.setProperty('--bundle-progress', safeProgress + '%');
      root.style.setProperty('--bundle-progress-scale', String(safeProgress / 100));
      root.querySelectorAll('[data-bundle-progress]').forEach(function (el) {
        el.setAttribute('aria-valuenow', String(safeCount));
        el.classList.toggle('is-unlocked', active);
      });
      root.querySelectorAll('[data-bundle-progress-bar], #top-prog-bar, #sum-prog-bar, #drw-sum-prog-bar').forEach(function (el) {
        el.style.width = safeProgress + '%';
        el.classList.toggle('unlocked', active);
      });
    }

    function setDateSummary(prefix, dateValue) {
      var row = root.querySelector('#' + prefix + 'summary-date-row');
      var val = root.querySelector('#' + prefix + 'summary-date-val');
      var status = root.querySelector('#' + prefix + 'summary-date-status');
      if (!row || !val || !status) return;
      if (dateValue) {
        row.classList.remove('summary-date-missing');
        val.textContent = formatPartyDate(dateValue);
        status.textContent = '✓';
      } else {
        row.classList.add('summary-date-missing');
        val.textContent = labels.dateRequired || 'Select party date';
        status.textContent = '!';
      }
    }

    function selectedItems() {
      return Object.keys(state.selected).map(function (key) { return state.selected[key]; });
    }

    function addonItems() {
      return Object.keys(state.addons).map(function (key) { return state.addons[key]; });
    }

    function upsellItems() {
      return Object.keys(state.upsell).map(function (key) { return state.upsell[key]; });
    }

    function switchTab(idx) {
      activeTab = Math.max(0, Math.min(2, Number(idx) || 0));
      hydrateProducts(['inf', 'food', 'decor'][activeTab]);
      [0, 1, 2].forEach(function (i) {
        var panel = root.querySelector('#panel-' + i);
        var footer = root.querySelector('#sf-' + i);
        var tab = root.querySelector('#tab-' + i);
        var dot = root.querySelector('#dot-' + i);
        if (panel) panel.classList.toggle('active', i === activeTab);
        if (footer) footer.style.display = i === activeTab ? 'flex' : 'none';
        if (tab) {
          tab.classList.toggle('active', i === activeTab);
          tab.classList.toggle('done', i < activeTab);
        }
        if (dot) dot.textContent = i < activeTab ? '✓' : String(i + 1);
      });
      var steps = root.querySelector('.steps-wrap');
      if (steps && window.innerWidth > 640) {
        steps.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      queueSaveDraft();
    }

    function hydrateProducts(section) {
      if (!section || section === 'inf') return;
      var productsSource = root.querySelector('[data-products-template="' + section + '"]');
      if (!productsSource) return;
      var grid = root.querySelector(section === 'float' ? '#upsell-grid' : '#' + section + '-grid');
      if (!grid) return;
      if (productsSource.tagName === 'TEMPLATE') {
        grid.appendChild(productsSource.content.cloneNode(true));
      } else {
        var productsHtml = productsSource.textContent || '';
        try {
          productsHtml = JSON.parse(productsHtml);
        } catch (error) {
          // Support plain HTML sources as well as JSON-encoded HTML.
        }
        if (productsHtml) {
          grid.appendChild(document.createRange().createContextualFragment(productsHtml));
        }
      }
      productsSource.remove();
      normalizeBuilderDigits(grid);
      updateCardActions();
      if (section === 'float') syncUpsellFilters();
    }

    function hydrateAllProducts() {
      ['food', 'decor', 'float'].forEach(hydrateProducts);
    }

    function filterProducts(section, cat, button) {
      var panel = button.closest('.step-panel');
      if (!panel) return;
      panel.querySelectorAll('.chip').forEach(function (chip) {
        chip.classList.toggle('active', chip === button);
      });
      var limit = section === 'inf' ? 9 : 9999;
      var visibleCount = 0;
      var matchingCount = 0;
      root.querySelectorAll('[data-section="' + section + '"]').forEach(function (card) {
        var match = cat === 'all' || card.dataset.cat === cat;
        if (match) matchingCount += 1;
        if (match && visibleCount < limit) {
          card.classList.remove('hidden');
          visibleCount += 1;
        } else {
          card.classList.add('hidden');
        }
      });
      var viewMore = panel.querySelector('[data-view-more]');
      if (viewMore) {
        viewMore.dataset.expanded = 'false';
        viewMore.style.display = matchingCount > limit ? 'block' : 'none';
        viewMore.textContent = (document.documentElement.dir === 'rtl' ? 'عرض جميع الـ ' : 'View All ') + matchingCount + (document.documentElement.dir === 'rtl' ? ' ↓' : ' ↓');
      }
    }

    function syncUpsellFilters() {
      var counts = { all: 0 };
      root.querySelectorAll('#upsell-grid .upsell-card').forEach(function (card) {
        var cat = (card.dataset.upsellCat || '').trim();
        counts.all += 1;
        if (cat) counts[cat] = (counts[cat] || 0) + 1;
      });

      var activeHidden = false;
      root.querySelectorAll('[data-upsell-filter]').forEach(function (button) {
        var cat = button.dataset.upsellFilter || 'all';
        var hasMatches = cat === 'all' || Boolean(counts[cat]);
        button.hidden = !hasMatches;
        button.style.display = hasMatches ? '' : 'none';
        if (!hasMatches && button.classList.contains('active')) {
          button.classList.remove('active');
          activeHidden = true;
        }
      });

      if (activeHidden || !root.querySelector('[data-upsell-filter].active')) {
        var allButton = root.querySelector('[data-upsell-filter="all"]');
        if (allButton) allButton.classList.add('active');
      }
    }

    function toggleViewMore(button) {
      var section = button.dataset.viewMore;
      var panel = button.closest('.step-panel');
      var active = panel ? panel.querySelector('.chip.active') : null;
      var cat = active ? active.dataset.cat : 'all';
      var expanded = button.dataset.expanded === 'true';
      var shown = 0;
      root.querySelectorAll('[data-section="' + section + '"]').forEach(function (card) {
        var match = cat === 'all' || card.dataset.cat === cat;
        if (!match) {
          card.classList.add('hidden');
          return;
        }
        if (expanded && shown >= 9) card.classList.add('hidden');
        else card.classList.remove('hidden');
        shown += 1;
      });
      button.dataset.expanded = expanded ? 'false' : 'true';
      button.textContent = expanded ? labels.viewAll || 'View All ↓' : (document.documentElement.dir === 'rtl' ? 'عرض أقل ↑' : 'Show Less ↑');
    }

    function toggleProduct(card) {
      var id = card.dataset.id;
      if (!id) return;
      if (state.selected[id]) {
        delete state.selected[id];
        card.classList.remove('sel');
      } else {
        state.selected[id] = productFromCard(card);
        card.classList.add('sel');
      }
      clearErrors();
      updateUI();
    }

    function toggleAddon(card) {
      var key = 'addon_' + Array.prototype.indexOf.call(root.querySelectorAll('.addon-card:not(.upsell-card)'), card);
      if (state.addons[key]) {
        delete state.addons[key];
        card.classList.remove('sel');
      } else {
        state.addons[key] = addonFromCard(card, key);
        card.classList.add('sel');
      }
      updateUI();
    }

    function toggleUpsell(card) {
      var id = card.dataset.upsellId;
      if (!id) return;
      if (state.upsell[id]) {
        delete state.upsell[id];
        card.classList.remove('addon-selected');
      } else {
        state.upsell[id] = upsellFromCard(card);
        card.classList.add('addon-selected');
      }
      updateUI();
    }

    function removeItem(id) {
      delete state.selected[id];
      root.querySelectorAll('[data-id="' + id + '"]').forEach(function (card) { card.classList.remove('sel'); });
      updateUI();
    }

    function removeAddon(key) {
      delete state.addons[key];
      root.querySelectorAll('.addon-card:not(.upsell-card)').forEach(function (card, idx) {
        if ('addon_' + idx === key) card.classList.remove('sel');
      });
      updateUI();
    }

    function removeUpsell(id) {
      delete state.upsell[id];
      root.querySelectorAll('.upsell-card[data-upsell-id="' + id + '"]').forEach(function (card) {
        card.classList.remove('addon-selected');
      });
      updateUI();
    }

    function renderList(prefix, items, addons, upsells) {
      var list = root.querySelector('#' + prefix + 'sel-items');
      var empty = root.querySelector('#' + prefix + 'empty-hint');
      if (!list) return;
      list.querySelectorAll('.sel-item').forEach(function (el) { el.remove(); });
      items.forEach(function (item) {
        var price = item.section === 'inf' || item.section === 'food' ? item.price * state.days : item.price;
        var type = item.type === 'rent' ? labels.rent : labels.buy;
        list.insertAdjacentHTML('beforeend',
          '<div class="sel-item"><div class="sel-thumb">' + (item.img ? '<img src="' + item.img + '" alt="">' : '') + '</div>' +
          '<div class="sel-info"><div class="sel-name">' + textFor(item) + '</div><div class="sel-price">' + money(price) + '</div><span class="sel-type ' + (item.type === 'rent' ? 'rent' : 'buy') + '">' + type + '</span></div>' +
          '<button class="sel-rm" type="button" data-rid="' + item.id + '" aria-label="' + (labels.remove || 'Remove') + '">×</button></div>'
        );
      });
      addons.forEach(function (addon) {
        list.insertAdjacentHTML('beforeend',
          '<div class="sel-item"><div class="sel-thumb">' + addon.icon + '</div><div class="sel-info"><div class="sel-name">' + textFor(addon) + '</div><div class="sel-price">' + money(addon.price) + '</div><span class="sel-type buy">' + (labels.addon || 'Add-on') + '</span></div><button class="sel-rm-addon" type="button" data-akey="' + addon.key + '">×</button></div>'
        );
      });
      upsells.forEach(function (item) {
        list.insertAdjacentHTML('beforeend',
          '<div class="sel-item"><div class="sel-thumb">' + (item.img ? '<img src="' + item.img + '" alt="">' : '') + '</div><div class="sel-info"><div class="sel-name">' + textFor(item) + '</div><div class="sel-price">' + money(item.price) + '</div><span class="sel-type buy">' + (labels.buy || 'Buy') + '</span></div><button class="sel-rm-upsell" type="button" data-ukey="' + item.id + '">×</button></div>'
        );
      });
      if (empty) empty.style.display = items.length || addons.length || upsells.length ? 'none' : 'block';
    }

    function updateUI() {
      state.days = daysInput ? Math.max(1, parseInt(daysInput.value, 10) || 1) : 1;
      var dateValue = dateInput ? dateInput.value : '';
      if (guestsInput) state.guests = guestsInput.value;
      if (venueInput) state.venue = venueInput.value;
      if (notesInput) state.notes = notesInput.value;
      var items = selectedItems();
      var addons = addonItems();
      var upsells = upsellItems();
      var infItems = items.filter(function (i) { return i.section === 'inf'; });
      var foodItems = items.filter(function (i) { return i.section === 'food'; });
      var decorItems = items.filter(function (i) { return i.section === 'decor'; });
      var infSub = infItems.reduce(function (s, i) { return s + i.price * state.days; }, 0);
      var foodSub = foodItems.reduce(function (s, i) { return s + i.price * state.days; }, 0);
      var decorSub = decorItems.reduce(function (s, i) { return s + i.price; }, 0);
      var addonSub = addons.reduce(function (s, i) { return s + i.price; }, 0);
      var upsellSub = upsells.reduce(function (s, i) { return s + i.price; }, 0);
      var bundleCount = infItems.length + foodItems.length + decorItems.length;
      var discountActive = bundleCount >= 3;
      var discountBase = infSub + foodSub + decorSub;
      var discountAmt = discountActive ? Math.round(discountBase * bundleDiscountRate) : 0;
      var total = infSub + foodSub + decorSub + addonSub + upsellSub + delivery - discountAmt;
      var anySelected = items.length || addons.length || upsells.length;
      var displayTotal = anySelected ? total : 0;
      var prog = Math.min(bundleCount / 3, 1) * 100;

      setDisplay('stt-amount', money(displayTotal));
      setDisplay('drw-stt-amount', money(displayTotal));
      setDisplay('stt-breakdown', anySelected ? [money(infSub + foodSub + decorSub + addonSub + upsellSub), '+', money(delivery), '-', money(discountAmt)].join(' ') : (root.querySelector('#stt-breakdown') || {}).textContent || '');
      setDisplay('drw-stt-breakdown', anySelected ? [money(infSub + foodSub + decorSub + addonSub + upsellSub), '+', money(delivery), '-', money(discountAmt)].join(' ') : (root.querySelector('#drw-stt-breakdown') || {}).textContent || '');
      setVisible('stt-disc-msg', discountActive);
      setVisible('drw-stt-disc-msg', discountActive);
      setDisplay('inf-subtotal', money(infSub));
      setDisplay('drw-inf-subtotal', money(infSub));
      setDisplay('food-subtotal', money(foodSub));
      setDisplay('drw-food-subtotal', money(foodSub));
      setDisplay('decor-subtotal', money(decorSub));
      setDisplay('drw-decor-subtotal', money(decorSub));
      setDisplay('upsell-subtotal', money(upsellSub));
      setDisplay('drw-upsell-subtotal', money(upsellSub));
      setDisplay('discount-val', '-' + money(discountAmt));
      setDisplay('drw-discount-val', '-' + money(discountAmt));
      setDisplay('total-val', money(displayTotal));
      setDisplay('drw-total-val', money(displayTotal));
      setVisible('food-row', foodSub > 0);
      setVisible('drw-food-row', foodSub > 0);
      setVisible('decor-row', decorSub > 0);
      setVisible('drw-decor-row', decorSub > 0);
      setVisible('upsell-row', upsellSub > 0);
      setVisible('drw-upsell-row', upsellSub > 0);

      updateProgressBars(prog, discountActive, bundleCount);
      setDisplay('bcat-inf-n', String(infItems.length));
      setDisplay('bcat-food-n', String(foodItems.length));
      setDisplay('bcat-decor-n', String(decorItems.length));
      setDisplay('bcat-total', Math.min(bundleCount, 3) + ' / 3');
      ['bcat-inf', 'bcat-food', 'bcat-decor'].forEach(function (id) {
        var active = id === 'bcat-inf' ? infItems.length : id === 'bcat-food' ? foodItems.length : decorItems.length;
        root.querySelectorAll('#' + id).forEach(function (el) { el.classList.toggle('active', active > 0); });
      });
      root.querySelectorAll('#bcat-total').forEach(function (el) { el.classList.toggle('unlocked', discountActive); });
      setDisplay('sum-prog-hint', discountActive ? (labels.discountUnlocked || '') : (labels.discountLocked || ''));
      setDisplay('drw-sum-prog-hint', discountActive ? (labels.discountUnlocked || '') : (labels.discountLocked || ''));
      root.querySelectorAll('#disc-badge, #drw-disc-badge').forEach(function (el) {
        el.textContent = discountActive ? (document.documentElement.dir === 'rtl' ? 'مفعّل' : 'Unlocked') : (document.documentElement.dir === 'rtl' ? 'مقفل' : 'Locked');
      });

      [0, 1, 2].forEach(function (i) {
        var count = i === 0 ? infItems.length : i === 1 ? foodItems.length : decorItems.length;
        var badge = root.querySelector('#tab-sel-' + i + ' .sel-num');
        if (badge) badge.textContent = count;
      });

      updateDateTriggerValue(dateValue);
      setDateSummary('', dateValue);
      setDateSummary('drw-', dateValue);
      renderList('', items, addons, upsells);
      renderList('drw-', items, addons, upsells);

      var summaryCount = items.length + addons.length + upsells.length;
      var mcbItems = root.querySelector('#mcb-items');
      if (mcbItems) mcbItems.textContent = summaryCount ? summaryCount + ' item(s) selected' : (labels.noItems || 'No items selected');
      var mcbTotal = root.querySelector('#mcb-total');
      if (mcbTotal) mcbTotal.innerHTML = money(displayTotal) + ' <small>' + (labels.details || '+ details') + ' <span class="mcb-arrow">↑</span></small>';
      updateCardActions();
      normalizeBuilderDigits(root);
      queueSaveDraft();
    }

    function clearErrors() {
      root.querySelectorAll('#cart-validation-error, #drw-cart-validation-error').forEach(function (el) {
        el.classList.remove('show');
      });
      var dateCard = root.querySelector('#fc-date');
      if (dateCard) dateCard.classList.remove('date-required');
    }

    function showError(message, dateError) {
      root.querySelectorAll('#cart-validation-error, #drw-cart-validation-error').forEach(function (el) {
        el.textContent = message;
        el.classList.add('show');
      });
      if (dateError && root.querySelector('#fc-date')) root.querySelector('#fc-date').classList.add('date-required');
    }

    function resetCheckoutButtons() {
      root.querySelectorAll('[data-add-bundle], [data-mobile-add]').forEach(function (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
    }

    function restoreCheckoutState() {
      resetCheckoutButtons();
      refreshPartyDateMinimum();
      updateUI();
      setCheckoutCta();
    }

    function validate() {
      refreshPartyDateMinimum();
      var items = selectedItems();
      var hasBaseProduct = items.some(function (item) {
        return item.section === 'inf' || item.section === 'food' || item.section === 'decor';
      });
      if (!dateInput || !dateInput.value || dateInput.value < dateInput.min) {
        if (dateInput) dateInput.value = '';
        showError(labels.dateRequired || 'Please select a party date.', true);
        if (dateTrigger) dateTrigger.focus();
        updateUI();
        return false;
      }
      if (!hasBaseProduct) {
        showError(labels.itemRequired || 'Please select at least 1 item.', false);
        return false;
      }
      clearErrors();
      return true;
    }

    function addBundle() {
      updateUI();
      if (!validate()) {
        if (window.innerWidth <= 640) openDrawer();
        return;
      }
      var bundleId = 'GP-' + Date.now();
      var items = [];
      var rentalContexts = [];
      selectedItems().forEach(function (item) {
        var rentalDays = item.section === 'inf' || item.section === 'food' ? state.days : 1;
        var properties = {
          'Bundle': labels.bundleName || 'Garden Party Bundle',
          'Bundle ID': bundleId,
          'Party Date': dateInput.value,
          'Rental Days': String(rentalDays),
          'Delivery City': labels.deliveryCity || 'Jeddah',
          'Item Type': item.type === 'rent' ? labels.rent : labels.buy,
          'Price Basis': item.section === 'inf' || item.section === 'food' ? 'per day' : 'one-time'
        };
        if (item.type === 'rent') {
          properties['شروط الايجار'] = 'Checked';
          properties.Date = rentalDateRange(dateInput.value, rentalDays);
          // IzyRent's checkout validation requires this hidden booking marker.
          properties.__izyrentValidation = Date.now() + ':' + rentalDays;
          rentalContexts.push({
            productId: Number(item.productId),
            variantId: Number(item.variantId),
            date: properties.Date,
            quantity: rentalDays
          });
        }
        items.push({
          id: Number(item.variantId),
          quantity: rentalDays,
          properties: properties
        });
      });
      upsellItems().forEach(function (item) {
        if (!item.variantId) return;
        items.push({
          id: Number(item.variantId),
          quantity: 1,
          properties: {
            'Bundle': labels.bundleName || 'Garden Party Bundle',
            'Bundle ID': bundleId,
            'Party Date': dateInput.value,
            'Rental Days': '1',
            'Delivery City': labels.deliveryCity || 'Jeddah',
            'Item Type': labels.buy || 'Buy',
            'Price Basis': 'one-time'
          }
        });
      });

      if (!items.length) return;
      root.querySelectorAll('[data-add-bundle], [data-mobile-add]').forEach(function (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      });
      var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : (function () {
            var localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
            return localeMatch ? '/' + localeMatch[1] + '/' : '/';
          })();
      var removePreviousGardenPartyItems = function () {
        return fetch(routesRoot + 'cart.js?izyrent', {
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to read cart before replacing bundle');
            return response.json();
          })
          .then(function (cart) {
            var updates = {};
            (cart.items || []).forEach(function (item) {
              var properties = item.properties || {};
              var existingBundleId = properties['Bundle ID'];
              if (typeof existingBundleId === 'string' && existingBundleId.indexOf('GP-') === 0) {
                updates[item.key] = 0;
              }
            });
            if (!Object.keys(updates).length) return cart;
            return fetch(routesRoot + 'cart/update.js?izyrent', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ updates: updates })
            }).then(function (response) {
              if (!response.ok) throw new Error('Unable to replace previous garden party bundle');
              return response.json();
            });
          });
      };
      var syncIzyRentCheckout = function () {
        if (!rentalContexts.length) return Promise.resolve();
        return fetch(routesRoot + 'cart.js?izyrent', {
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to read cart');
            return response.json();
          })
          .then(function (cart) {
            var rentalItems = items
              .filter(function (item) {
                return item.properties && item.properties.__izyrentValidation;
              })
              .map(function (item) {
                return {
                  variant_id: item.id,
                  quantity: item.quantity,
                  properties: item.properties
                };
              });
            var existingItems = (cart.items || []).map(function (item) {
              return {
                variant_id: item.variant_id,
                quantity: item.quantity,
                properties: item.properties
              };
            });
            var rentalContext = rentalContexts[0];
            var izySettings = window.izyrentSettings;
            if (typeof izySettings === 'string') {
              try {
                izySettings = JSON.parse(izySettings.replace(/=>/g, ':'));
              } catch (error) {
                izySettings = {};
              }
            }
            return fetch('https://izyrent.speaz.com/front/get_discounts', {
              method: 'POST',
              body: JSON.stringify({
                shop: window.Shopify && window.Shopify.shop,
                cart: {
                  token: cart.token,
                  deposit: izySettings && izySettings.deposit && izySettings.deposit.id,
                  items: existingItems.concat(rentalItems),
                  atc: {
                    product_id: rentalContext.productId,
                    variant_id: rentalContext.variantId,
                    addons: '',
                    date: rentalContext.date,
                    quantity: rentalContext.quantity
                  }
                }
              })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to validate rental');
            return response.json();
          })
          .then(function (validation) {
            if (!validation || !validation.token || validation.token === 'unavailable') {
              throw new Error('Rental validation failed: ' + JSON.stringify(validation || {}));
            }
            return fetch(routesRoot + 'cart/update.js?izyrent', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                attributes: { __izyrentPrice: validation.token }
              })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to save rental validation');
            return response.json();
          });
      };
      var cartRequest = new XMLHttpRequest();
      // Mark this as an IzyRent-managed add so its generic cart guard does not
      // remove the rental and redirect visitors back to the product page.
      cartRequest.open('POST', routesRoot + 'cart/add.js?izyrent', true);
      cartRequest.setRequestHeader('Content-Type', 'application/json');
      cartRequest.setRequestHeader('Accept', 'application/json');
      cartRequest.onload = function () {
        if (cartRequest.status >= 200 && cartRequest.status < 300) {
          window.location.assign('/checkout');
          return;
        }
        showError(labels.cartError || 'Cart error', false);
        resetCheckoutButtons();
      };
      cartRequest.onerror = function () {
        showError(labels.cartError || 'Cart error', false);
        resetCheckoutButtons();
      };
      removePreviousGardenPartyItems()
        .then(syncIzyRentCheckout)
        .then(function () {
          cartRequest.send(JSON.stringify({ items: items }));
        })
        .catch(function (error) {
          console.error('Kumm checkout preparation failed', error);
          showError(labels.cartError || 'Cart error', false);
          resetCheckoutButtons();
        });
    }

    function openDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.add('open');
      overlay.classList.add('open');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      document.documentElement.style.overflow = '';
    }

    function appendProductInfoSpec(content, icon, label, value) {
      if (!value) return;
      var spec = document.createElement('div');
      spec.className = 'prod-detail-spec';
      var iconNode = document.createElement('span');
      iconNode.className = 'prod-detail-icon';
      iconNode.textContent = icon || '';
      var copy = document.createElement('span');
      var labelNode = document.createElement('span');
      labelNode.className = 'prod-detail-label';
      labelNode.textContent = label || '';
      var valueNode = document.createElement('strong');
      valueNode.textContent = value;
      copy.appendChild(labelNode);
      copy.appendChild(valueNode);
      spec.appendChild(iconNode);
      spec.appendChild(copy);
      content.appendChild(spec);
    }

    function ensureProductInfo(card) {
      if (!card) return null;
      var existing = card.querySelector('.prod-detail');
      if (existing) return existing;
      var image = card.querySelector('.prod-img');
      if (!image) return null;

      var panel = document.createElement('div');
      panel.className = 'prod-detail';
      panel.setAttribute('aria-hidden', 'true');
      var close = document.createElement('button');
      close.className = 'prod-detail-close';
      close.type = 'button';
      close.setAttribute('data-info-close', '');
      close.setAttribute('aria-label', card.dataset.infoCloseLabel || labels.close || 'Close');
      close.textContent = '×';
      var content = document.createElement('div');
      content.className = 'prod-detail-content';

      appendProductInfoSpec(content, card.dataset.infoOneIcon, card.dataset.infoOneLabel, card.dataset.infoOneValue);
      appendProductInfoSpec(content, card.dataset.infoTwoIcon, card.dataset.infoTwoLabel, card.dataset.infoTwoValue);
      appendProductInfoSpec(content, card.dataset.infoThreeIcon, card.dataset.infoThreeLabel, card.dataset.infoThreeValue);
      if (card.dataset.infoNote) {
        var note = document.createElement('div');
        note.className = 'prod-detail-note';
        var noteIcon = document.createElement('span');
        noteIcon.textContent = '💡';
        var noteCopy = document.createElement('span');
        noteCopy.textContent = card.dataset.infoNote;
        note.appendChild(noteIcon);
        note.appendChild(noteCopy);
        content.appendChild(note);
      }

      panel.appendChild(close);
      panel.appendChild(content);
      image.appendChild(panel);
      return panel;
    }

    function openProductInfo(card) {
      if (!card) return;
      root.querySelectorAll('.kumm-prod-card.info-open').forEach(function (openCard) {
        if (openCard !== card) openCard.classList.remove('info-open');
      });
      card.classList.add('info-open');
      var panel = ensureProductInfo(card);
      if (panel) panel.setAttribute('aria-hidden', 'false');
    }

    function closeProductInfo(card) {
      if (!card) return;
      card.classList.remove('info-open');
      var panel = card.querySelector('.prod-detail');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    }

    root.addEventListener('click', function (event) {
      var checkoutTrigger = event.target.closest('[data-add-bundle], [data-mobile-add]');
      if (checkoutTrigger) {
        event.preventDefault();
        event.stopPropagation();
        if (!checkoutTrigger.disabled) addBundle();
        return;
      }
      if (event.target.closest('[data-restore-draft]')) {
        applyDraft(pendingDraft);
        dismissRestorePrompt();
        return;
      }
      if (event.target.closest('[data-clear-draft]')) {
        clearDraft();
        dismissRestorePrompt();
        return;
      }
      var switcher = event.target.closest('[data-switch-tab]');
      if (switcher) {
        switchTab(Number(switcher.dataset.switchTab || 0));
        return;
      }
      if (event.target.closest('[data-next-step]')) {
        var active = root.querySelector('.step-tab.active');
        var idx = active ? Number(active.id.replace('tab-', '')) : 0;
        switchTab(Math.min(2, idx + 1));
        return;
      }
      if (event.target.closest('[data-review-order]')) {
        var summary = root.querySelector('[data-desktop-summary]');
        if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var filter = event.target.closest('[data-filter-section]');
      if (filter) {
        filterProducts(filter.dataset.filterSection, filter.dataset.cat, filter);
        return;
      }
      var viewMore = event.target.closest('[data-view-more]');
      if (viewMore) {
        toggleViewMore(viewMore);
        return;
      }
      var upsellFilter = event.target.closest('[data-upsell-filter]');
      if (upsellFilter) {
        if (upsellFilter.hidden) return;
        var cat = upsellFilter.dataset.upsellFilter;
        upsellFilter.closest('.filter-bar').querySelectorAll('.chip').forEach(function (chip) {
          chip.classList.toggle('active', chip === upsellFilter);
        });
        root.querySelectorAll('#upsell-grid .upsell-card').forEach(function (card) {
          card.style.display = cat === 'all' || card.dataset.upsellCat === cat ? '' : 'none';
        });
        return;
      }
      var infoClose = event.target.closest('[data-info-close]');
      if (infoClose) {
        closeProductInfo(infoClose.closest('.kumm-prod-card'));
        return;
      }
      var infoToggle = event.target.closest('[data-info-toggle]');
      if (infoToggle) {
        var infoCard = infoToggle.closest('.kumm-prod-card');
        if (infoCard && infoCard.classList.contains('info-open')) closeProductInfo(infoCard);
        else openProductInfo(infoCard);
        return;
      }
      var prodCard = event.target.closest('.kumm-prod-card');
      if (prodCard) {
        event.preventDefault();
        event.stopPropagation();
        toggleProduct(prodCard);
        return;
      }
      var upsellCard = event.target.closest('.upsell-card');
      if (upsellCard && event.target.closest('.upsell-tog')) {
        toggleUpsell(upsellCard);
        return;
      }
      var addonCard = event.target.closest('.addon-card:not(.upsell-card)');
      if (addonCard && event.target.closest('.addon-tog')) {
        toggleAddon(addonCard);
        return;
      }
      var remove = event.target.closest('.sel-rm');
      if (remove) {
        removeItem(remove.dataset.rid);
        return;
      }
      var removeAddonButton = event.target.closest('.sel-rm-addon');
      if (removeAddonButton) {
        removeAddon(removeAddonButton.dataset.akey);
        return;
      }
      var removeUpsellButton = event.target.closest('.sel-rm-upsell');
      if (removeUpsellButton) {
        removeUpsell(removeUpsellButton.dataset.ukey);
        return;
      }
      if (event.target.closest('[data-open-drawer]')) {
        openDrawer();
        return;
      }
      if (event.target.closest('[data-close-drawer]')) {
        closeDrawer();
        return;
      }
    });

    root.querySelectorAll('.party-gallery-video').forEach(function (video) {
      video.addEventListener('play', function () {
        root.querySelectorAll('.party-gallery-video').forEach(function (otherVideo) {
          if (otherVideo !== video && !otherVideo.paused) otherVideo.pause();
        });
      });
    });

    if (dateInput) {
      refreshPartyDateMinimum();
      dateInput.addEventListener('change', function () {
        refreshPartyDateMinimum();
        clearErrors();
        updateUI();
      });
    }
    if (dateTrigger) dateTrigger.addEventListener('click', openPartyDateCalendar);
    if (calendarPrevious) calendarPrevious.addEventListener('click', function () { moveCalendarMonth(-1); });
    if (calendarNext) calendarNext.addEventListener('click', function () { moveCalendarMonth(1); });
    if (calendarGrid) {
      calendarGrid.addEventListener('click', function (event) {
        var button = event.target.closest('[data-calendar-date]');
        if (!button || button.disabled) return;
        selectCalendarDate(button.dataset.calendarDate);
      });
    }
    root.querySelectorAll('[data-calendar-close]').forEach(function (button) {
      button.addEventListener('click', closePartyDateCalendar);
    });
    if (dateDialog) {
      dateDialog.addEventListener('click', function (event) {
        if (event.target === dateDialog) closePartyDateCalendar();
      });
    }
    if (daysInput) daysInput.addEventListener('change', updateUI);
    if (guestsInput) guestsInput.addEventListener('change', updateUI);
    if (venueInput) venueInput.addEventListener('change', updateUI);
    if (notesInput) notesInput.addEventListener('input', updateUI);
    // Mobile Safari can restore the page from its back/forward cache with the
    // checkout CTA still carrying the loading state set before navigation.
    // Clear it both before the cache snapshot and after the page is restored.
    window.addEventListener('pagehide', resetCheckoutButtons);
    window.addEventListener('pageshow', restoreCheckoutState);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) restoreCheckoutState();
    });
    window.addEventListener('resize', queueStickySummaryOffset);
    window.addEventListener('scroll', queueStickySummaryOffset, { passive: true });
    window.addEventListener('load', queueStickySummaryOffset, { once: true });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      root.querySelectorAll('.kumm-prod-card.info-open').forEach(closeProductInfo);
    });

    var savedDraft = readDraft();
    root.querySelectorAll('[data-filter-section="inf"].active').forEach(function (button) {
      filterProducts('inf', button.dataset.cat || 'all', button);
    });
    syncUpsellFilters();
    var upsellSection = root.querySelector('#upsell-sec');
    if (upsellSection && 'IntersectionObserver' in window) {
      var upsellObserver = new IntersectionObserver(function (entries, observer) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        hydrateProducts('float');
        observer.disconnect();
      }, { rootMargin: '700px 0px' });
      upsellObserver.observe(upsellSection);
    } else {
      hydrateProducts('float');
    }
    updateUI();
    saveReady = true;
    if (savedDraft) showRestorePrompt(savedDraft);
    queueStickySummaryOffset();
    setCheckoutCta();
    normalizeBuilderDigits(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-kumm-party-builder]').forEach(initBuilder);
  });
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-kumm-party-builder]').forEach(initBuilder);
  });
})();
